export class AsyncEvent {
  /*
    An event that can be awaited

    Usage:

    const ev = new AsyncEvent()
    ...
    # Wait until the event is triggered
    await ev.wait()

    # In another task the event can be triggered
    # For example in a callback
    ev.trigger()
   */
  private promise: Promise<void>;
  private resolver!: CallableFunction;
  constructor() {
    this.promise = new Promise((resolve) => {
      this.resolver = resolve;
    });
  }

  public trigger(): void {
    this.resolver();
  }

  public async wait(): Promise<void> {
    return await this.promise;
  }
}

export const sleep = (ms: number): Promise<void> => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

export function debounce<T extends (...args: any[]) => void>(
  func: T,
  delay: number
): (...args: Parameters<T>) => void {
  let timeoutId: number | undefined;

  return function (...args: Parameters<T>) {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    timeoutId = window.setTimeout(() => {
      // @ts-ignore
      func.apply(this, args);
    }, delay);
  };
}

export function removeQueryParams(url: string, params: string[]): string {
  const parsedUrl = new URL(url);
  for (const paramName of params) {
    parsedUrl.searchParams.delete(paramName);
  }
  return parsedUrl.toString();
}

export function chunked<T>(arr: T[], size: number): T[][] {
  return arr.reduce(
    (acc, _, i) => (i % size ? acc : [...acc, arr.slice(i, i + size)]),
    [] as T[][]
  );
}
